import { styled } from "@mui/material/styles";
import { Tooltip, tooltipClasses } from "@mui/material";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "100%",

    color: "white",
    backgroundColor: "transparent",
  },
});

export function CustomMUITooltip({ content, icon }) {
  return (
    <StyledTooltip
      title={content}
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={2000}
      PopperProps={{
        popperOptions: {
          modifiers: [
            {
              name: "preventOverflow",
              // options: {
              //   boundary: "window", // Use the window as the boundary
              // },
              options: {
                altBoundary: true, // Check against the boundary of the container as well
                rootBoundary: "viewport", // Use the viewport as the boundary
                padding: 8, // Optional: Add some padding
              },
            },
            {
              name: "flip",
              options: {
                fallbackPlacements: ["top", "right", "bottom", "left"], // Default placements to try flipping
              },
            },
          ],
        },
        sx: {
          maxWidth: "100%",
          // Set a max width for the tooltip
        },
      }}
    >
      {icon}
    </StyledTooltip>
  );
}
